<template lang="pug">
  v-container.pa-0(fluid)
    v-list(style="height: 500px; overflow-y: scroll" )
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.name')}}
        v-list-item-content {{getName}}
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.status')}}
        v-list-item-content(:style="{color: getStatusColor}") {{getStatus}}
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.fromIbanColumnLabel')}}
        v-list-item-content {{getFormattedIban}}
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.variableSymbolColumnLabel')}}
        v-list-item-content {{transactionDetail.transaction.variableSymbol}}
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.specificSymbolColumnLabel')}}
        v-list-item-content {{getSpecificSymbol}}
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.constantSymbol')}}
        v-list-item-content {{transactionDetail.transaction.constantSymbol}}
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.amountColumnLabel')}}
        v-list-item-content {{getCredit}} €
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.createdAt')}}
        v-list-item-content {{getFormattedDate(this.transactionDetail.transaction.createdAt)}}
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.dateAvailable')}}
        v-list-item-content {{getFormattedDate(this.transactionDetail.transaction.dateAvailable)}}
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.datePosted')}}
        v-list-item-content {{getFormattedDate(this.transactionDetail.transaction.datePosted)}}
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.memo')}}
        v-list-item-content {{getMemo}}
      v-list-item
        v-list-item-content
          v-list-item-title {{$t('bankTransactionPage.reference')}}
        v-list-item-content {{getReference}}

</template>

<script lang="ts">
import Vue from "vue"
import {Component, Prop} from 'vue-property-decorator'
import BankTransaction from "@/model/BankTransaction/BankTransaction";
import moment from "moment/moment";

@Component({
  components: {
  }
})

export default class BankTransactionPropertiesTab extends Vue {
  @Prop({type: Object, required: false}) readonly transactionDetail!: BankTransaction

   get getName (): string {
    if(this.transactionDetail.boarder && this.transactionDetail.boarder.person && this.transactionDetail.boarder.person.firstName && this.transactionDetail.boarder.person.familyName) {
      return `${this.transactionDetail.boarder.person.firstName} ${this.transactionDetail.boarder.person.familyName}`
    } else {
      return '-'
    }

  }

   get getCredit () {
    if(this.transactionDetail.transaction.amount){
      return (this.transactionDetail.transaction.amount / 100).toFixed(2)
    } else {
      return 0
    }
  }

  getFormattedDate (item: string): string {
    return moment(item).format('D.M.YYYY')
  }

   get getSpecificSymbol () {
    if(this.transactionDetail.transaction.specificSymbol === 0) {
      return '-'
    } else {
      return this.transactionDetail.transaction.specificSymbol
    }
  }

  get getReference () {
    if(this.transactionDetail.transaction.name === 'not-provided') {
      return '-'
    } else {
      return this.transactionDetail.transaction.name
    }
  }

  get getMemo () {
    if(this.transactionDetail.transaction.memo === 'not-provided') {
      return '-'
    } else {
      return this.transactionDetail.transaction.memo
    }
  }

  get getStatus() {
    switch (this.transactionDetail.transaction.status) {
      case 'done': return this.$t(`bankTransactionPage.doneTransaction`)
      case 'to_wallet': return this.$t(`bankTransactionPage.to_walletTransaction`)
      case 'not_processed': return this.$t(`bankTransactionPage.not_processedTransaction`)
      case 'ignored': return this.$t(`bankTransactionPage.ignoredTransaction`)
      case 'unknown': return this.$t(`bankTransactionPage.unknownTransaction`)
      case 'error': return this.$t(`bankTransactionPage.errorTransaction`)

      default: return ''
    }
  }

  get getStatusColor (): string {
    switch (this.transactionDetail.transaction.status) {
      case 'done': return 'green'
      case 'to_wallet': return 'green'
      case 'not_processed': return 'orange'
      case 'ignored': return 'grey'
      case 'unknown': return 'grey'
      case 'error': return 'red'

      default: return ''
    }
  }

   get getFormattedIban() {
    return this.transactionDetail.transaction.fromIban.replace(/\S{4}(?=.)/g, '$& ')
  }

  onCloseButtonClick(){
    this.$emit('close')
  }


  mounted() {
  }
}
</script>

<style lang="stylus" scoped>
.style
  color: green
</style>
